"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const WbSunny_1 = __importDefault(require("@mui/icons-material/WbSunny"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const WeatherDataWrapper = styled_components_1.default.div `
  text-align: center;
  margin-bottom: 10px;
  @media (min-width: 744px) {
    margin-bottom: 14px;
  }

  display: flex;
  flex-direction: column;
  align-items: center;

  width: 25%; // 4

  @media (min-width: 500px) {
    width: 16.66%; // 6
  }

  @media (min-width: 744px) {
    width: 12.5%; // 8
  }

  @media (min-width: 1024px) {
    width: 10%; // 10
  }

  .tile-link {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background-color: ${(props) => {
    /* eslint-disable prefer-destructuring */
    const { position, theme } = props;
    if (!position && position !== 0) {
        return theme.palette.mainAppColor.main;
    }
    const colorTiles = theme.palette.colorTiles;
    const chosenColor = colorTiles[position % colorTiles.length];
    return chosenColor;
    /* eslint-disable prefer-destructuring */
}};

    &.bareiss {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      background-image: ${() => "url( /images/other/bareissTransparent.png )"};
    }

    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    height: 65px;
    width: 65px;
  }

  .tile-title {
    line-height: 16px;
    letter-spacing: 0.4px;
    font-weight: 400;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    margin-top: 3px;
    width: 100%;

    @media (min-width: 1024px) {
      margin-top: 7px;
    }

    @media (min-width: 769px) {
      font-size: 0.875rem; // body2
    }
  }
`;
const SvgWrapper = styled_components_1.default.div `
  height: 35px;

  svg {
    height: 35px;
    width: auto;

    path,
    circle {
      fill: ${(props) => props.theme.palette.mainAppColor.contrastText};
    }
  }

  &.svg-temp-fix {
    path:first-of-type {
      fill: unset;
    }
  }
`;
const WeatherTile = (props) => {
    if (!props.weatherData || !props.weatherData.current) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const bareissClass = props.isBareissBrand ? "bareiss" : "";
    return (react_1.default.createElement(WeatherDataWrapper, { position: props.position, className: bareissClass },
        react_1.default.createElement(react_router_dom_1.Link, { to: {
                pathname: `${props.baseUrl}/weather`,
                search: props.location.search,
            }, className: `${bareissClass} tile-link` },
            react_1.default.createElement(SvgWrapper, null,
                react_1.default.createElement(WbSunny_1.default, null))),
        react_1.default.createElement(material_1.Typography, { variant: "caption", className: "tile-title" }, i18n_js_1.default.t("weather"))));
};
const mapStoreToProps = (store) => ({
    baseUrl: store.getValue("baseUrl"),
    weatherData: store.getValue("weather"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(WeatherTile));
